import { apiCall, ApiConfig } from '../../../config/api'
import { ProductExternalReference } from '../../../interfaces/Producto/ProductExternalReference'
import { Filter } from '../../../components/_WMS/FilterComponent/types'
import { GenericOrderBy } from '../../../components/_EOS/Table/types'

export const getProductExternalReferences = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<ProductExternalReference>
) => {
  const queryParams = new URLSearchParams()
  queryParams.append('pageIndex', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  filters.forEach((filter) => {
    queryParams.append(filter.key, filter.value)
  })

  if (orderBy) {
    const sorters = {
      datafield: orderBy.field.toString(),
      sortOrder: orderBy.direction
    }
    queryParams.append('sorters', JSON.stringify(sorters))
  }

  return apiCall(
    'GET',
    `${ApiConfig.ProductExternalReferenceApi}?${queryParams.toString()}`
  )
}

export const getProductExternalReferenceById = (
  productExternalReferenceId: number
) => {
  return apiCall(
    'GET',
    `${ApiConfig.ProductExternalReferenceApi}/${productExternalReferenceId}`
  )
}

export const createProductExternalReference = (
  data: ProductExternalReference
) => {
  return apiCall('POST', ApiConfig.ProductExternalReferenceApi, data)
}

export const updateProductExternalReference = (
  productExternalReferenceId: number,
  data: ProductExternalReference
) => {
  return apiCall(
    'PATCH',
    `${ApiConfig.ProductExternalReferenceApi}/${productExternalReferenceId}`,
    data
  )
}

export const deleteProductExternalReference = (
  productExternalReferenceId: number
) => {
  return apiCall(
    'DELETE',
    `${ApiConfig.ProductExternalReferenceApi}/${productExternalReferenceId}`
  )
}
